import React from "react";
import styles from "./CommunityEngagements.module.css";

interface Props {
  data: string;
}

const CEDescription: React.FC<Props> = ({ data }) => {
  return (
    <div className="container">
      <span className={styles.description}>{data}</span>
    </div>
  );
};

export default CEDescription;
